// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfz_a bhe_vr bhe_ea bhe_a","MenuItem__Btn":"bfz_b bhe_z"};